module.exports = __webpack_public_path__ + "media/thankyou_message_3.50f55c01.mp3";